import { Fragment, FunctionComponent, useState } from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";

import { Button } from "primereact/button";
import { classNames } from "primereact/utils";

import { faPlus } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { IGlossaryFileSupportExtended } from "../../../../../features/translation/TranslationHeader/GlossarySelection/GlossarySelection.types";
import { translationKeys } from "../../../../../models/app-translation-keys";
import { ManageGlossaryDialog } from "../ManageGlossaryDialog/ManageGlossaryDialog";

export interface IUploadFilesToIndexButtonProps {
  glossary?: IGlossaryFileSupportExtended;
  isDisabled?: boolean;
  onUploadCompleted(): void;
}

const RawAddGlossaryButton: FunctionComponent<IUploadFilesToIndexButtonProps> = (
  props: IUploadFilesToIndexButtonProps,
) => {
  const { t } = useTranslation();

  const [isPopupVisible, setIsPopupVisible] = useState(false);

  const glossaryTranslationKeys = translationKeys.adminArea.glossary;

  const handleCloseUplaodFilesToIndexDialog = (success?: boolean) => {
    setIsPopupVisible(false);

    if (success) {
      props.onUploadCompleted();
    }
  };

  return (
    <Fragment>
      {isPopupVisible && (
        <ManageGlossaryDialog
          glossary={props.glossary}
          isVisible={isPopupVisible}
          onHide={handleCloseUplaodFilesToIndexDialog}
        />
      )}

      <Button
        id="create-glossary-button"
        className={classNames({ disabled: props.isDisabled })}
        onClick={() => !props.isDisabled && setIsPopupVisible(true)}
        disabled={props.isDisabled}
      >
        <FontAwesomeIcon icon={faPlus} />

        {t(glossaryTranslationKeys.actions.createGlossary)}
      </Button>
    </Fragment>
  );
};

export const AddGlossaryButton = observer(RawAddGlossaryButton);
